// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams, Outlet } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Store from './pages/Store';
import ProductPage from './components/ProductPage';
import Checkout from "./pages/Billing";
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Return from './pages/Return';
import Shipping from './pages/Shipping';
import Cancellation from './pages/Cancellation';
import Karungali from './karungali/Karungali';
import ThankYou from './pages/ThankYou';
import { CartProvider } from './components/CartContext';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import translations from './utils/data';
import { createProductUrl, createUrlSlug } from './utils/urlSlugs';
import Blog from './pages/Blog';
import Blogs from './pages/Blogs';

// Lookups
const getProductById = (id) => translations?.products?.product?.find((p) => p.id === id);
const getProductBySlugOrName = (s) => {
  const target = createUrlSlug(s);
  return translations?.products?.product?.find((p) => {
    const byStoredSlug = p?.slug ? createUrlSlug(p.slug) === target : false;
    const byName = p?.name ? createUrlSlug(p.name) === target : false;
    return byStoredSlug || byName;
  });
};

const ProductPageWithSlug = () => {
  const { slug } = useParams();

  // legacy numeric id support
  if (/^\d+$/.test(slug)) {
    const legacy = getProductById(Number(slug));
    return legacy
      ? <Navigate to={createProductUrl(legacy.slug || legacy.name)} replace />
      : <Navigate to="/shop" replace />;
  }

  const product = getProductBySlugOrName(slug);
  if (!product) return <Navigate to="/shop" replace />;

  // canonicalize only when normalized param != normalized stored slug/name
  const normalizedParam = createUrlSlug(slug);
  const normalizedProduct = createUrlSlug(product.slug || product.name);
  if (normalizedParam !== normalizedProduct) {
    return <Navigate to={createProductUrl(product.slug || product.name)} replace />;
  }

  return <ProductPage product={product} />;
};

function App() {
  useEffect(() => {
    AOS.init({ delay: 300, duration: 900, easing: 'ease' });
  }, []);

  return (
    <ErrorBoundary>
      <div className="App overflow-hidden">
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/thank-you" element={<ThankYou />} />
              <Route element={<Layout><Outlet /></Layout>}>
                <Route index element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/shop" element={<Store />} />
                <Route path="/product/:slug" element={<ProductPageWithSlug />} />
                <Route path="/billing" element={<Checkout />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/return" element={<Return />} />
                <Route path="/shipping" element={<Shipping />} />
                <Route path="/cancellation" element={<Cancellation />} />
                <Route path="/karungalimala" element={<Karungali />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<Blogs />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
